/* Five Star Catering Equipment — Theme JS */

(function () {
  'use strict';

  /* =====================
     TOAST NOTIFICATION
     ===================== */
  function showToast(message, duration) {
    duration = duration || 3000;
    var existing = document.querySelector('.toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'toast';
    toast.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
      '<span>' + message + '</span>';
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('show');
      });
    });

    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () { toast.remove(); }, 350);
    }, duration);
  }

  window.showToast = showToast;

  /* =====================
     CART COUNT UPDATE
     ===================== */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cart-count');
        if (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('has-items', cart.item_count > 0);
        }
      })
      .catch(function () {});
  }

  /* =====================
     LAZY IMAGES
     ===================== */
  if ('IntersectionObserver' in window) {
    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    var imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imageObserver.unobserve(img);
        }
      });
    });
    lazyImages.forEach(function (img) { imageObserver.observe(img); });
  }

  /* =====================
     SMOOTH ANCHOR SCROLL
     ===================== */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* =====================
     ANNOUNCEMENT BAR CLOSE
     ===================== */
  var annClose = document.getElementById('ann-close');
  if (annClose) {
    annClose.addEventListener('click', function () {
      var bar = document.getElementById('announcement-bar');
      if (bar) {
        bar.style.display = 'none';
        try { sessionStorage.setItem('ann-closed', '1'); } catch (e) {}
      }
    });
    try {
      if (sessionStorage.getItem('ann-closed') === '1') {
        var bar = document.getElementById('announcement-bar');
        if (bar) bar.style.display = 'none';
      }
    } catch (e) {}
  }

  /* =====================
     INIT
     ===================== */
  document.addEventListener('DOMContentLoaded', function () {
    updateCartCount();
  });

})();
